import { render, staticRenderFns } from "./VolunteerGuestsModal.vue?vue&type=template&id=2fd3d235&"
import script from "./VolunteerGuestsModal.vue?vue&type=script&lang=js&"
export * from "./VolunteerGuestsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports